import { getItauFontFamily } from '../typography-utils';

const MuiTypography = {
  styleOverrides: {
    root: ({ ownerState }) => {
      if (ownerState.sx?.fontSize === undefined) {
        return {};
      }

      return {
        fontFamily: getItauFontFamily(ownerState.sx.fontSize),
      };
    },
  },
};

export default MuiTypography;
